module.exports = __webpack_public_path__ + "img/step3.96eaf351.png";